import { Injectable } from '@angular/core';
import { prop, propObject, required } from '@rxweb/reactive-form-validators';
import { Distributor } from '../../../../../models/agents/invitation-register';
import { Part } from '../../../../../models/agents/part';
import { ResponsibleAddress } from '../../../../../models/agents/responsible-address.enum';
import { PartType } from '../../../../../models/enums/part-type-enum';
import { PersonType } from '../../../../../models/enums/person-type.enum';
import { ProfileClass } from '../../../../../models/enums/profile-class.enum';
import { UploadCompanyCategoryType } from '../../../../../models/enums/upload-category-type-enum';
import { BaseCompany } from './base-company.model';

@Injectable()
export class InvestorFundModel extends BaseCompany {
  constructor(persona?: PersonType) {
    super();
    this.responsibleAddress = new ResponsibleAddress(persona);
    this.distributor = new Distributor(persona);
    this.partAdministrator = new Part();
    this.partMananger = new Part();
    this.partCustodian = new Part();
    this.partMananger.partType = PartType.Manager;
    this.partAdministrator.partType = PartType.Administrator;
    this.partCustodian.partType = PartType.Custodian;
    this.allowedFiles = [
      UploadCompanyCategoryType.SocialDocument,
      UploadCompanyCategoryType.FoundRule
    ];
    this.profileClass = this.profileClass == null ? ProfileClass.FundoInvestimento : this.profileClass;
  }

  @required()
  cvmProfile: string;

  @propObject(ResponsibleAddress)
  responsibleAddress: ResponsibleAddress;

  @prop()
  cellphone: string;

  @required()
  establishmentDate: string;

  @required()
  mainActivity: string;

  @prop()
  ginNumber: string;

  @prop()
  isinNumber: string;

  @prop()
  galgoCode: string;

  @required()
  condominiumForm: string;

  @propObject(Part)
  partAdministrator: Part;

  @propObject(Part)
  partMananger: Part;

  @propObject(Part)
  partCustodian: Part;

  @prop()
  exclusiveFund = false;

  @prop()
  profileClass: string;

  @propObject(Distributor)
  distributor: Distributor;

}
